import * as actionTypes from './actionTypes'

const initialState = {
    bundleFeeData: [],
    customFeeData: []
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_BUNDLE_FEES:
            state = {
                ...state,
                [action.payload.name]: action.payload.data,
            }
            break;
        case actionTypes.UPDATE_CUSTOM_FEES:
            state = {
                ...state,
                [action.payload.name]: action.payload.data,
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default reducer;
